<div
  class="message-set-wrapper"
  [ngClass]="{
    center:
      currentMessage.images.length === 0 && currentMessage.videos.length === 0
  }"
  >
  @if (currentMessage.images.length > 0 || currentMessage.videos.length > 0) {
    <div
      class="thumbnail-container"
      >
      @if (currentMessage.images.length > 0) {
        <div class="image-thumbnail">
          <img [src]="currentMessage.images[0].large_url" />
        </div>
      }
      @if (currentMessage.videos.length > 0) {
        <div class="video-thumbnail">
          @if (currentMessage.videos[0].encodings.length > 0) {
            <img
              [src]="currentMessage.videos[0].encodings[0].thumbnails[0].file"
              />
          }
          @if (currentMessage.videos[0].encodings.length == 0) {
            <svg
              class="icon grid"
              viewBox="0 0 32 32"
              >
              <use xlink:href="#icon-video"></use>
            </svg>
          }
        </div>
      }
      <div class="key">
        <div class="zoom-icon"></div>
        <span>{{ currentMessage.images.length > 0 ? "zoom" : "play" }}</span>
      </div>
    </div>
  }

  <div class="message-content">
    <div class="subject">
      @if (currentMessage.images[0] || currentMessage.videos[0]) {
        <h2>
          {{ currentMessage.subject | truncate: 40 }}
        </h2>
      }
      @if (!currentMessage.images[0] && !currentMessage.videos[0]) {
        <h2>
          {{ currentMessage.subject | truncate: 55 }}
        </h2>
      }
    </div>
    <div class="body">
      @if (currentMessage.images[0] || currentMessage.videos[0]) {
        <p>
          {{ currentMessage.body | truncate: 180 }}
        </p>
      }
      @if (!currentMessage.images[0] && !currentMessage.videos[0]) {
        <p>
          {{ currentMessage.body | truncate: 235 }}
        </p>
      }
    </div>
  </div>
</div>
<div class="choices-wrapper">
  <cm-choice-selector
    [choices]="currentMessage.choices"
    (choiceSelected)="processSelection($event)"
    [columns]="1"
    [choiceWidth]="900"
    [choiceHeight]="40"
  ></cm-choice-selector>
</div>
